(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product__media-toggle[data-media-id]');
    if (!button) return;

    const opener = button.closest('modal-opener');
    const modalSelector = opener && opener.getAttribute('data-modal');
    const modal = modalSelector ? document.querySelector(modalSelector) : document.querySelector('.product-media-modal');
    const content = modal && modal.querySelector('.product-media-modal__content');

    if (content) {
      content.scrollTop = 0;
      content.scrollLeft = 0;
    }
  });
})();
